import * as React from "react";

import { ViewExtraLarge, ViewMedium, Viewport } from "@shared-ui/viewport-context";
import { UitkSpacing } from "uitk-react-spacing";

export interface DesktopHeroAttributionProps {
  destinationHero: React.ReactElement;
}

export const DesktopHeroAttribution = ({ destinationHero }: DesktopHeroAttributionProps) => (
  <Viewport>
    <ViewMedium>
      <UitkSpacing padding={{ blockend: "six", inlinestart: "three" }}>
        <div className="destination-hero">{destinationHero}</div>
      </UitkSpacing>
    </ViewMedium>
    <ViewExtraLarge>
      <UitkSpacing padding={{ blockend: "six" }}>
        <div className="destination-hero">{destinationHero}</div>
      </UitkSpacing>
    </ViewExtraLarge>
  </Viewport>
);
